import { render, staticRenderFns } from "./abstract-place.vue?vue&type=template&id=585c9bfa&scoped=true"
import script from "./abstract-place.vue?vue&type=script&lang=js"
export * from "./abstract-place.vue?vue&type=script&lang=js"
import style0 from "./abstract-place.vue?vue&type=style&index=0&id=585c9bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c9bfa",
  null
  
)

export default component.exports